import React from "react";

import { Modal } from "antd";
import DeleteIcon from "../../icon/deleteIcon.jsx";
import { Box } from "@mui/material";
import PropTypes from "prop-types";

export function Confirm(props) {
  const { when, onOK, onCancel, title, okText, cancelText, message, isDelete } = props;
  const backGroundColor = isDelete ? "#ff5252" : "#19b2ab";
  const color = isDelete ? "#ffffff" : "#21262f";

  return when ? (
    <Modal
      title={<Box component={"p"} style={{color: 'white'}}>{title}</Box>}
      open={when}
      okText={okText}
      cancelText={cancelText}
      onOk={onOK}
      onCancel={onCancel}
      okButtonProps={{
        type: "primary",
        icon: isDelete ? <DeleteIcon width={16} height={16} color={"#ffffff"} /> : <></>,
        style: {
          color,
          fontSize: "12px",
          fontWeight: "500",
          backgroundColor: backGroundColor,
          borderRadius: "2px",
        },
      }}
      cancelButtonProps={{
        type: "link",
        style: {
          color: "#19b2ab",
          fontSize: "12px",
          fontWeight: "500",
        },
      }}
      closable={false}
      maskClosable={false}
      width={'fit-content'}
      style={{top: 165, paddingBottom: 0}}
      styles={{
        mask: {
          backgroundColor: "rgba(38, 50, 63, 0.7)",
        },
        content: {
          backgroundColor: "#161a1e",
          color: "#ffffff",
          textAlign: "center",
          padding: "40px 70px",
        },
        header: {
          backgroundColor: "unset",
          color: "#ffffff",
        },
        footer: {
          textAlign: "center",
          marginTop: "28px",
        }
      }}
    >
      {message}
    </Modal>
  ) : null;
}

Confirm.propTypes = {
  when: PropTypes.bool,
  onOK: PropTypes.func,
  onCancel: PropTypes.func,
  title: PropTypes.string,
  okText: PropTypes.string,
  cancelText: PropTypes.string,
  message: PropTypes.string,
  isDelete: PropTypes.bool,
}